import React from "react";
import { Tooltip } from "@mui/joy";

type ActionTooltipProps = {
  title: React.ReactNode;
  disabled?: boolean;
  children: React.ReactElement;
};

export default function ActionTooltip({ title, disabled = false, children }: ActionTooltipProps) {
  const content = disabled ? <span style={{ display: "inline-flex" }}>{children}</span> : children;

  // Touch-friendly: show on touchstart, keep visible long enough to read on mobile.
  return (
    <Tooltip title={title} enterTouchDelay={0} leaveTouchDelay={3000}>
      {content}
    </Tooltip>
  );
}
